/**
 * @generated SignedSource<<ae84c8be50e8a658d06f38cc7a98b468>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfilePreviewRelay_workedOn$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly object: {
        readonly data: {
          readonly __typename: "BitbucketPullRequest";
          readonly href: AGG$URL | null | undefined;
        } | {
          readonly __typename: "ConfluenceBlogPost";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluenceFooterComment";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluenceInlineComment";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluencePage";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ConfluenceWhiteboard";
          readonly links: {
            readonly base: string | null | undefined;
            readonly webUi: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "ExternalDocument";
          readonly url: string | null | undefined;
        } | {
          readonly __typename: "JiraIssue";
          readonly webUrl: AGG$URL | null | undefined;
        } | {
          readonly __typename: "JiraPlatformComment";
          readonly issue: {
            readonly webUrl: AGG$URL | null | undefined;
          } | null | undefined;
          readonly webUrl: AGG$URL | null | undefined;
        } | {
          readonly __typename: "JiraServiceManagementComment";
          readonly issue: {
            readonly webUrl: AGG$URL | null | undefined;
          } | null | undefined;
          readonly webUrl: AGG$URL | null | undefined;
        } | {
          readonly __typename: "LoomVideo";
          readonly loomUrl: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      };
    };
  }>;
  readonly " $fragmentType": "UserProfilePreviewRelay_workedOn";
};
export type UserProfilePreviewRelay_workedOn$key = {
  readonly " $data"?: UserProfilePreviewRelay_workedOn$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelay_workedOn">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v1 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v0/*: any*/)
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  (v2/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": (v3/*: any*/)
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserProfilePreviewRelay_workedOn",
  "selections": [
    {
      "concreteType": "ActivityItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ActivityNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "ActivityObject",
              "kind": "LinkedField",
              "name": "object",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluencePageLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluencePage"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceBlogPostLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluenceBlogPost"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceWhiteboardLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v0/*: any*/)
                        }
                      ],
                      "type": "ConfluenceWhiteboard"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "ConfluenceInlineComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "ConfluenceFooterComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v3/*: any*/),
                      "type": "JiraIssue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v4/*: any*/),
                      "type": "JiraPlatformComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v4/*: any*/),
                      "type": "JiraServiceManagementComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "url"
                        }
                      ],
                      "type": "ExternalDocument"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "href"
                        }
                      ],
                      "type": "BitbucketPullRequest"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": "loomUrl",
                          "kind": "ScalarField",
                          "name": "url"
                        }
                      ],
                      "type": "LoomVideo"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "ActivityConnection"
};
})();

(node as any).hash = "077c742e52d5e8b87c9af9de51c5f7fa";

export default node;
